"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPriceWithDiscountAmount = exports.getPriceWithDiscountPercentage = exports.getPriceWithDiscount = exports.getCents = exports.precisionRound = exports.roundTo = exports.getCurrencySymbol = exports.simpleFormat = exports.replaceCurrencyCymbols = exports.formatCurrency = void 0;

var formatCurrency = function formatCurrency(price, billingInfoFromAuthState) {
  var minimumFractionDigits = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;
  price = parseFloat(price);

  if (isNaN(price) || !billingInfoFromAuthState) {
    return '';
  } // get currency from billinginfo call


  var currency = billingInfoFromAuthState.code || 'USD';
  var formatter = new Intl.NumberFormat([], {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: minimumFractionDigits
  });
  var result = formatter.format(price);
  return replaceCurrencyCymbols(result);
};

exports.formatCurrency = formatCurrency;

var replaceCurrencyCymbols = function replaceCurrencyCymbols(currencyString) {
  var result = currencyString.replace('US$', '$').replace('A$', '$').replace('CA$', 'C$');
  return result;
};

exports.replaceCurrencyCymbols = replaceCurrencyCymbols;

var simpleFormat = function simpleFormat(priceString, currencyInput) {
  return getCurrencySymbol(currencyInput) + priceString.replace(/[^0-9.,]/g, '');
};

exports.simpleFormat = simpleFormat;

var getCurrencySymbol = function getCurrencySymbol(currencyInput) {
  var price = 0;
  var currency = currencyInput || 'USD';
  var priceString = new Intl.NumberFormat([], {
    style: 'currency',
    currency: currency
  }).format(price).toString();
  var result = priceString.replace(/[\s.,\d]+/g, '');
  return replaceCurrencyCymbols(result);
};

exports.getCurrencySymbol = getCurrencySymbol;

var roundTo = function roundTo(n, digits) {
  if (digits === undefined) {
    digits = 0;
  }

  var multiplicator = Math.pow(10, digits);
  n = parseFloat((n * multiplicator).toFixed(11));
  return (Math.round(n) / multiplicator).toFixed(2);
};

exports.roundTo = roundTo;

var precisionRound = function precisionRound(number, precision) {
  var factor = Math.pow(10, precision);
  return Math.round(number * factor) / factor;
};

exports.precisionRound = precisionRound;

var getCents = function getCents(price) {
  price = typeof price === 'number' ? price : 0;
  var cents = (price % 1).toFixed(4);
  var centsRounded = precisionRound(Number(cents), 2);
  var centsString = centsRounded + '';
  centsString = centsString.substring(centsString.indexOf('.') + 1);

  if (centsString.length === 1) {
    centsString += '0';
  }

  return '.' + centsString;
};

exports.getCents = getCents;

var getPriceWithDiscount = function getPriceWithDiscount(price) {
  var discount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return getPriceWithDiscountPercentage(price, discount);
};

exports.getPriceWithDiscount = getPriceWithDiscount;

var getPriceWithDiscountPercentage = function getPriceWithDiscountPercentage(price) {
  var discount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return price - price * (discount / 100);
};

exports.getPriceWithDiscountPercentage = getPriceWithDiscountPercentage;

var getPriceWithDiscountAmount = function getPriceWithDiscountAmount(price) {
  var discount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return price - discount;
};

exports.getPriceWithDiscountAmount = getPriceWithDiscountAmount;